import request from "@/utils/request2";

// 新增商品配饰
export function uploadFile(formData) {
  return request({
    url: "/common/OssUploadImg",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  });
}
